
<!-- command-bar -->
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nuevo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Procesos</h2>
  </div>
  <app-data-table
    tableId="datatableProcesos"
    [serverSide]="true"
    [serverData]="getDataTableProcesos"
    [columns]="columnas"
    (loadedGrid)="gridLoaded($event)"
    (custom)="customClick($event)"
    [buttonsOptions]="dtOptButtons"
  ></app-data-table>
</div>

<!-- Nuevo -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-procesos" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Proceso</div>
    <form
      [formGroup]="processForm"
      (ngSubmit)="crearEditarProceso()"
      name="processForm"
    >
      <div class="ms-Dialog-content input-grid form-group">
        <div>
          <app-text-box
            [frm]="processForm"
            formControlName="Nombre"
            type="text"
            [required]="true"
            label="Nombre"
          ></app-text-box>
        
        </div>
        <div>
          <app-text-area
            [frm]="processForm"
            formControlName="Descripcion"
            [required]="true"
            label="Descripción"
            rows="3"
          ></app-text-area>
          
        </div>
        <div>
          <div class="ms-Dropdown dropdown" tabindex="0">
            <label class="ms-Label is-required" for="Estado"> Estado </label>
            <i class="ms-Dropdown-caretDown ms-Icon ms-Icon--ChevronDown"></i>
            <select
              class="form-control"
              id="estadoProceso"
              [(ngModel)]="procesoObj.Estado"
              formControlName="Estado"
            >
              <option disabled>Seleccione...</option>
              <option value="1">Diseño</option>
              <option value="2">Pruebas</option>
              <option value="3">Produccion</option>
            </select>
          </div>
          <p
            style="color: brown"
            *ngIf="
              processForm.controls.Estado.invalid &&
              (processForm.controls.Estado.dirty ||
                processForm.controls.Estado.touched)
            "
          >
            El estado es requerido
          </p>
        </div>
        <div>
          <app-text-box
            [frm]="processForm"
            formControlName="Version"
            type="number"
            [required]="true"
            label="Versión"
            (input)="onInputChange($event)"
          ></app-text-box>
        </div>
        <app-check-box
          [frm]="processForm"
          formControlName="TodosUsuarios"
          label="Todos Usuarios"
        ></app-check-box>
        <app-check-box
          [frm]="processForm"
          formControlName="Activo"
          label="Activo"
        ></app-check-box>
      </div>
      <app-form-buttons
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Crear"
        [labelLoading]="textoBotonProcesando"
        [frm]="processForm"
        (cancel)="clearFormProceso()"
        [validate]="true"
      >
      </app-form-buttons>
    </form>
  </div>
</div>

<!-- Modal -->
<div class="docs-DialogExample-lgHeader success">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-succes" appPreventOutsideClick> 
    <div class="ms-Dialog-title">Proceso Almacenado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha almacenado el Proceso.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button
        class="ms-Button ms-Dialog-action ms-Button--primary"
        (click)="cerrarModal()"
      >
        <span class="ms-Button-label">Aceptar</span>
      </button>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="docs-DialogExample-lgHeader duplicado">
  <div class="ms-Dialog ms-Dialog--lgHeader duplicado-succes" >
    <div class="ms-Dialog-title">Proceso Duplicado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha duplicado el Proceso quedando este con el nombre {{ procesoDuplicado }}.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button type="button" class="ms-Button ms-Dialog-action">Aceptar</button>

    </div>
  </div>
</div>

<!-- Modal Duplicar -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-duplicar" appPreventOutsideClick>
    <div class="ms-Dialog-title">¿Desea duplicar el proceso?</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Duplicar Proceso</p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
      <button class="ms-Button ms-Button--primary" (click)="duplicarProceso()">
        <span class="ms-Button-label">Aceptar</span>
      </button>
      <div class="ms-Spinner" [hidden]="!botonProcesando">
        <div class="ms-Spinner-label">
          {{ textoBotonProcesando }}
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Modal Importar -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader modal-Importar" appPreventOutsideClick>
    <div class="ms-Dialog-title" *ngIf="auxImport">¿Desea importar el proceso?</div>
    <div class="ms-Dialog-title" *ngIf="!auxImport">¿Desea exportar el proceso?</div>
    <div class="ms-Dialog-content">
      <div *ngIf="auxImport">
        <p class="ms-Dialog-subText" *ngIf="isEmpty == 'true'">El proceso está vacio, ¿desea importar un Proceso?</p>
        <p class="ms-Dialog-subText" *ngIf="isEmpty == 'false'">El proceso ya tiene una configuracion previa, ¿está seguro de importar un nuevo Proceso?</p>

      </div>

      <p class="ms-Dialog-subText" *ngIf="!auxImport">Exportar Proceso</p>
    </div>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
      <button class="ms-Button ms-Button--primary" *ngIf="auxImport" (click)="importarProceso()">
        <span class="ms-Button-label">Aceptar</span>
      </button>
      <button class="ms-Button ms-Button--primary" *ngIf="!auxImport" (click)="exportarProceso()">
        <span class="ms-Button-label">Aceptar</span>
      </button>
      <div class="ms-Spinner" [hidden]="!botonProcesando">
        <div class="ms-Spinner-label">
          {{ textoBotonProcesando }}
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="docs-DialogExample-lgHeader importado-s">
  <div class="ms-Dialog ms-Dialog--lgHeader importado-succes">
    <div class="ms-Dialog-title">Proceso importado Correctamente</div>
    <div class="ms-Dialog-content">
      <p class="ms-Dialog-subText">Se ha importado el Proceso.</p>
    </div>
    <div class="ms-Dialog-actions">
      <button type="button" class="ms-Button ms-Dialog-action">Aceptar</button>

    </div>
  </div>
</div>




 <app-modal-notify #crearModal></app-modal-notify>

<!-- Modal para Ver Diagrama del Proceso -->
<app-generic-modal
  [isVisible]="modalDiagramaVisible"
  [title]="'Proceso '+ idProcesoTitle + ' - '+ NombreProcesoTitle"
  [showLoading]="!mostrarDiagrama"
  loadingMessage="Cargando diagrama..."
  showActionButton="true"
  actionButtonIcon="ms-Icon--Download"
  actionButtonTooltip="Descargar imagen"
  (actionButtonClick)="downloadProcesoPDF()"
  [actionButtons]="analisisActionButtons"
  (actionButtonsClick)="onModalActionButtonClick($event)"
  (closeModal)="cerrarModalDiagrama()">
  <app-diagram-viewer 
    *ngIf="mostrarDiagrama"
    [xmlContent]="xmlContent"
    [readOnly]="true"
    [showTooltips]="false"
    [showLegend]="false"
    [hideWatermark]="true"
    (analisisStateChange)="onAnalisisStateChange($event)"
    (analisisCBStateChange)="onAnalisisCBStateChange($event)">
  </app-diagram-viewer>
</app-generic-modal>
